<script setup lang="ts">
const { signOut, data } = useAuth()
const { t } = useI18n()

const localePath = useLocalePath()
const { isDashboardSearchModalOpen } = useUIState()
const { metaSymbol } = useShortcuts()

const items = computed(() => [
  [{
    slot: 'account',
    label: '',
    disabled: true
  }], [{
    label: t('auth.account_settings'),
    icon: 'i-heroicons-cog-8-tooth',
    to: localePath('/settings')
  }], [{
    label: t('auth.sign_out'),
    icon: 'i-heroicons-arrow-left-on-rectangle',
    click: async () => {
      signOut()
      await navigateTo(localePath('/'), { external: true});
    }
  }]
])
</script>

<template>
  <UDropdown
    mode="hover"
    :items="items"
    :ui="{ width: 'w-full', item: { disabled: 'cursor-text select-text' } }"
    :popper="{ strategy: 'absolute', placement: 'top' }"
    class="w-full"
  >
    <template #default="{ open }">
      <UButton
      v-if="data"
        color="gray"
        variant="ghost"
        class="w-full"
        :label="data.first_name + ' ' + data.last_name"
        :class="[open && 'bg-gray-50 dark:bg-gray-800']"
      >
        <template #leading>
          <UAvatar
            src="https://avatars.githubusercontent.com/u/739984?v=4"
            size="2xs"
          />
        </template>

        <template #trailing>
          <UIcon
            name="i-heroicons-ellipsis-vertical"
            class="w-5 h-5 ml-auto"
          />
        </template>
      </UButton>
    </template>

    <template #account>
      <div class="text-left">
        <i18n-t keypath="auth.signed_in_as" tag="div">
          <template v-slot:email>
            <p class="truncate font-medium text-gray-900 dark:text-white">
              {{ data.email }}
            </p>
          </template>
        </i18n-t>
      </div>
    </template>
  </UDropdown>
</template>
